@if (form) {
  <mat-card>
    <app-card-header
      [title]="title"
      icono="verified"
      [draggable]="!!dialogRef"
      [botonCerrar]="!!dialogRef"
      (cerrar)="cancelar()"
    ></app-card-header>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Entidad -->
        @if (!params?.idEntidad) {
          <app-content-card title="Entidad" icon="business">
            <irx-segmentado
              [(value)]="tipoEntidadSeleccionado"
              bloque
              class="tipo-toggle-group"
            >
              <irx-segmento value="vehiculo" class="tipo-toggle">
                <mat-icon>directions_car</mat-icon>
                Vehículo
              </irx-segmento>
              <irx-segmento value="alarma" class="tipo-toggle">
                <mat-icon>doorbell</mat-icon>
                Alarma
              </irx-segmento>
            </irx-segmentado>

            @if (tipoEntidadSeleccionado === 'vehiculo') {
              <ng-select
                [items]="searchVehiculos$ | async"
                [minTermLength]="3"
                bindLabel="identificacion"
                bindValue="_id"
                formControlName="idEntidad"
                placeholder="Buscar vehículo..."
                loadingText="Cargando..."
                typeToSearchText="Escribí para buscar..."
                notFoundText="No se encontraron resultados"
                [loading]="loadingVehiculos"
                [typeahead]="searchTermVehiculos$"
                (search)="searchVehiculos($event.term)"
                appendTo="body"
                class="entidad-select"
              ></ng-select>
            }

            @if (tipoEntidadSeleccionado === 'alarma') {
              <ng-select
                [items]="searchAlarmas$ | async"
                [minTermLength]="3"
                bindLabel="nombre"
                bindValue="_id"
                formControlName="idEntidad"
                placeholder="Buscar alarma..."
                loadingText="Cargando..."
                typeToSearchText="Escribí para buscar..."
                notFoundText="No se encontraron resultados"
                [loading]="loadingAlarmas"
                [typeahead]="searchTermAlarmas$"
                (search)="searchAlarmas($event.term)"
                appendTo="body"
                class="entidad-select"
              ></ng-select>
            }
          </app-content-card>
        }

        <!-- Fechas del Certificado -->
        <app-content-card title="Fechas del certificado" icon="event">
          <app-info-banner
            color="orange"
            icon="info"
            title="Las fechas solo son necesarias para certificados programados. Para certificados manuales se ignoran."
            [closable]="false"
            margin="0 0 16px 0"
          ></app-info-banner>

          <div class="dates-row">
            <div class="date-field">
              <app-datetime-picker
                [date]="form.value.fechaInicio?.toISOString()"
                [placeholder]="'Fecha y Hora de Inicio (Programado)'"
                (dateChange)="onFechaInicioChange($event)"
                [maxDate]="null"
              ></app-datetime-picker>
            </div>

            <div class="date-field">
              <app-datetime-picker
                [date]="form.value.fechaEmision?.toISOString()"
                [placeholder]="'Fecha y Hora de Fin (Programado)'"
                (dateChange)="onFechaEmisionChange($event)"
                [maxDate]="null"
              ></app-datetime-picker>
            </div>
          </div>
        </app-content-card>
      </mat-card-content>

      <!-- Acciones -->
      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="cancelar()">
          Cancelar
        </button>
        <button
          irxBoton="secundario"
          type="button"
          (click)="crearManualmente()"
          [disabled]="
            creandoManual || (!form.value.idEntidad && !params?.idEntidad)
          "
        >
          <mat-icon>add</mat-icon>
          Crear manualmente
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="
            !(form.value.idEntidad || params?.idEntidad) ||
            !form.value.fechaInicio ||
            !form.value.fechaEmision
          "
        >
          <mat-icon>check</mat-icon>
          Programar
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
}
